import React from 'react';
import PropTypes from 'prop-types';
import CollapsibleTextAreaWithCounter from '../../components/CollapsibleTextAreaWithCounter';

class MessagingSame extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    data: PropTypes.any,
    entryId: PropTypes.string.isRequired,
  };

  render() {
    const { onChange, data, entryId } = this.props;
    const name = `${entryId}.messaging`;
    const ariaLabel = `Enter a message for ${entryId}`;

    const value = typeof (data) === 'string' ? data : '';
    return (
      <CollapsibleTextAreaWithCounter
        name={name}
        value={value}
        aria-label={ariaLabel}
        onChange={onChange}
        placeholder="Enter Message..."
      />
    );
  }
}

export default MessagingSame;
